import useKeyPress from '@umijs/hooks/es/useKeyPress'
import { Button } from 'antd'
import * as React from 'react'

import { CloseIcon } from '../icons'
import { DrawerPushProps, DrawerProps, DrawerStyle } from './types'

import * as styles from './DrawerPush.module.less'
import * as drawerStyles from './Drawer.module.less'

// Default props
const defaultSiderWidth = '400px'
const defaultShowCloseButton = true

export const DrawerPush: React.FC<DrawerPushProps> = (props) => {
    const { config, content, drawer, visible } = props
    const siderWidth =
        config && config.siderWidth ? config.siderWidth : defaultSiderWidth
    const showCloseButton =
        config && config.showCloseButton
            ? config.showCloseButton
            : defaultShowCloseButton

    let animateContent: React.CSSProperties = {}
    let animateDrawer: React.CSSProperties = {}
    if (!visible && siderWidth) {
        animateContent = { width: `calc(100% + ${siderWidth})` }
        animateDrawer = { transform: `translateX(${siderWidth})` }
    }

    return (
        <div
            className={styles.drawerPush}
            style={{ gridTemplateColumns: `1fr ${siderWidth}` }}
        >
            <div className={styles.content} style={animateContent}>
                {content}
            </div>
            <div className={styles.drawer} style={animateDrawer}>
                <Drawer
                    {...drawer}
                    closeDrawer={props.onClose}
                    drawerStyle={config?.drawerStyle}
                    isVisible={visible}
                    showCloseButton={showCloseButton}
                />
            </div>
        </div>
    )
}

interface InnerDrawerProps extends DrawerProps {
    isVisible?: boolean
    closeDrawer?: () => void
    drawerStyle?: DrawerStyle
    showCloseButton: boolean
}

const Drawer: React.FC<InnerDrawerProps> = (props) => {
    const {
        closeDrawer,
        content,
        drawerStyle,
        footer,
        header,
        showCloseButton
    } = props
    useKeyPress(['esc'], (event) => {
        if (closeDrawer) {
            closeDrawer()
        }
    })

    return (
        <div className={drawerStyles.drawer} style={drawerStyle?.drawer}>
            {showCloseButton ? (
                <div className={drawerStyles.closeButtonWrapper}>
                    <Button
                        className={drawerStyles.closeButton}
                        icon={<CloseIcon />}
                        onClick={closeDrawer}
                    />
                </div>
            ) : null}
            {header ? (
                <div
                    className={drawerStyles.header}
                    style={drawerStyle?.header}
                >
                    {header}
                </div>
            ) : null}
            <div
                className={
                    header
                        ? drawerStyles.content
                        : drawerStyles.contentWithNoHeader
                }
                style={drawerStyle?.content}
            >
                {content}
            </div>
            {footer && (
                <div
                    className={drawerStyles.footer}
                    style={drawerStyle?.footer}
                >
                    {footer}
                </div>
            )}
        </div>
    )
}

// header ? (
//     drawerStyle.content
// ) : (
//     { marginTop: '48px', padding: '0 24px 24px 24px', ...drawerStyle.content }
// )
